import Vue from 'vue'
import SymbolConfig from "./symbol-config"
import {getCardInfo } from '@/request/request'
import vote from './card/vote/index.vue'
import "./css/index.less";

export const renderArticleInsert = function() {
    try {
        let shopInfoObj= []
        init()

        function init() {
                const mpPluginList = document.querySelectorAll('#mp-editor mp-plugin[data-type="66"]')
                if(mpPluginList?.length) {
                    mpPluginList.forEach((plugin)=>{
                        const type =  plugin?.getAttribute('data-type')
                        if(type) {
                            const item = {}
                            const info = eval(plugin?.getAttribute('data-info'))
                            if (SymbolConfig.shopCard.indexOf(+type) > -1 && info && info[0]) {
                                var key = info[0].cardUuid;
                                item.id = key
                                item.type = type
                                item.$el = plugin
                                shopInfoObj.push(item)
                            }
                        }
                    })
                    renderShopCard(shopInfoObj)
                }
        }
        function renderShopCard(params) {
            if(!params.length)return
            var ids = []
            params.forEach(function(item){
                ids.push(item.id)
            })
            if (ids?.length) {
                getCardData({ ids: ids.join(",") })
            }
        }

        function getCardData(params) {
            getCardInfo(params).then((res)=>{
                if(res && res.code == 2000000 && res.data?.length) {
                    const dataList = res.data
                    dataList.forEach((cardItem,i)=>{
                        cardItem.$el = shopInfoObj[i]?.$el
                        renderShopCardVote(cardItem)
                    })
                }
            })
        }
        // type 66
        function renderShopCardVote(cardInfo){
            const params = {
                el: document.createElement('div'),
                propsData:{
                    articleData: cardInfo,
                    page:'focus'
                },
            }
            const vueConstructor = Vue.extend(vote)
            const html = new vueConstructor(params)?.$el
            cardInfo?.$el?.appendChild(html)
        }


    } catch (error) {
        console.log('功能卡',error)
    }
}



